import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224 } from "@faire/web-api--source/indigofair/settings/LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224";

import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingLoggedOutHomepageNewTopBannerCopy =
  (): IThreeVariantXP =>
    useSetting(
      LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224,
      IThreeVariantXP.Bucket.CONTROL
    );

export const useAssignSettingLoggedOutHomepageNewTopBannerCopy = () =>
  useAssignSetting(LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224);
